<template>
    <div class="row participation-info-wrapper pastime-header-section" :class="{ 'column-layout' : !isDesktop }" ref="psHeaderSection" id="psHeaderSection">
        <div v-if="imgUrl" class="ps-banner-container" :class="{'col-auto' : !isDesktop}" ref="psBannerContainer" id="psBannerContainer">
            <img :src="imgUrl" :alt="title" ref="psBannerImg" id="psBannerImg"/>
        </div>
        <div class="col header-info-container" ref="psInfoContainer" id="psInfoContainer">
            <div class="participation-details">
                <h2 class="details-title"> {{ title }} </h2>
                <p class="details-description" v-html="description"/>
            </div>
            <div class="row mx-0 header-actions-container">
                <div v-if="buttonText" class="button-wrapper" :class="{'has-warning' : participationWarning}">
                    <button class="pastime-button" @click="actionControl(actionType)" :disabled="!enabled"> {{ buttonText }} </button>
                </div>
                <div class="header-links-container">
                    <span class="ps-header-link" @click="actionControl('see-faqs')"> {{ kStrings.kSEE_FAQ }} </span>
                    <span class="ps-header-link" @click="actionControl('see-rules')"> {{ kStrings.kSEE_RULES }} </span>
                </div>
                <p v-if="participationWarning" class="participation-warning">
                    <i class="ecom-info"/>
                    <!--                        <Popper v-if="participationWarning.popupMsg" position="top"
                                                    trigger="clickToToggle"
                                                    id="participationWarningId"
                                                    class="participation-warning-popup">
                                                <i slot="activator" class="ecom-info"/>
                                                {{ participationWarning.popupMsg }}
                                            </Popper>-->
                    <span class="warning-msg"> {{ participationWarning.popupMsg ? participationWarning.popupMsg : participationWarning.warningMsg }} </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import {store} from '@/store/pastimes';
import Popper from '@/components/Muffin/Popper';
export default {
    store,
    name: 'ParticipationHeader',
    components: {
        Popper  
    },
    props: {
        imgUrl: {type: String, default: null},
        title: {type: String, default: ''},
        description: {type: String, default: ''},
        buttonText: {type: String, default: ''},
        enabled: {type: Boolean, default: true},
        actionType: {type: String, default: 'modal'}, // modal or link/function etc
        participationWarning: {type: [Object, String], default: null},
    },
    data() {
        return {}
    },
    computed: {
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
    },
    watch: {},
    mounted() {
        this.$nextTick(() => {
            if(this.isDesktop && this.imgUrl) {
                this.bannerSectionSizing();
                window.removeEventListener("resize", this.bannerSectionSizing);
                window.addEventListener("resize", this.bannerSectionSizing);
            }
        });
    },
    methods: {
        actionControl(action = 'modal') {
            if(action == 'modal') {
                this.$emit('modal-status', true);
            } else {
                this.$emit(action);
            }
        },
        bannerSectionSizing() {
            let psBannerContainer = this.$refs.psBannerContainer;
            let psBannerImg = this.$refs.psBannerImg;
            let psHeaderSection = this.$refs.psHeaderSection;
            let psInfoContainer = this.$refs.psInfoContainer;
            
            if(!psBannerContainer) {
                psBannerContainer = document.getElementById('psBannerContainer');
            }
            if(!psBannerImg) {
                psBannerImg = document.getElementById('psBannerImg');
            }
            if(!psHeaderSection) {
                psHeaderSection = document.getElementById('psHeaderSection');
            }
            if(!psInfoContainer) {
                psInfoContainer = document.getElementById('psInfoContainer');
            }

            if(psBannerContainer && psBannerImg && psHeaderSection) {
                let psHeaderSectionWidth = psHeaderSection.clientWidth;
                psBannerContainer.style.width = psHeaderSectionWidth * 0.4 + 'px';
                if(psBannerContainer.clientWidth > 0) {
                    psBannerContainer.style.maxHeight = psBannerContainer.clientWidth / 2 + 'px';
                    //psBannerImg.style.height = psBannerContainer.clientWidth / 2 + 'px';
                    psBannerImg.style.maxHeight = psBannerContainer.clientWidth / 2 + 'px';
                    psInfoContainer.style.minHeight = ((psHeaderSectionWidth * 0.4) / 2) + 'px';
                }
            }
        }
    },
};
</script>

<style scoped>

</style>